export const bg = {
  title: 'Импресум',
  subtitle: 'Задължителни данни съгласно Регламент (ЕС) 2018/302 и естонския Търговски закон (äriseadustik) · Към дата: 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Доставчик на услуги',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Естония (Estonia)\n\n- **Registrikood (номер в търговския регистър):** 14744075\n- **ДДС № / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Регистър:** Eesti äriregister (Естонски търговски регистър)\n- **Правна форма:** Osaühing (OÜ) — дружество с ограничена отговорност съгласно естонското право\n- **Лицензирано и регулирано в:** Република Естония, Европейски съюз',
    },
    {
      id: 'responsible',
      title: 'Отговорно лице за съдържанието',
      body:
        '**Andreas A. Gleim**\nУправител / отговорен за съдържанието съгласно естонския Търговски закон (äriseadustik) и § 18 MStV (Германия)\n\nИмейл: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Контакт',
      body:
        'Имейл: [logixa.one/kontakt](/kontakt)\nУебсайт: [https://logixa.one](https://logixa.one)\n\nЗапитвания относно платформата, партньорства, преса и защита на личните данни можете да отправяте до нас на горепосочения имейл адрес или чрез [формуляра за контакт](/kontakt).',
    },
    {
      id: 'eu',
      title: 'Решаване на спорове в ЕС',
      body:
        'Европейската комисия предоставя платформа за онлайн решаване на спорове (ОРС):\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nНие не сме нито готови, нито задължени да участваме в процедура за решаване на спорове пред помирителен орган за потребители.',
    },
    {
      id: 'liability',
      title: 'Отговорност за съдържанието',
      body:
        'Като доставчик на услуги ние сме отговорни за собственото съдържание на тези страници съгласно § 7, ал. 1 TMG (Германия) и естонския InfoTS в съответствие с общите закони. Съгласно §§ 8 до 10 TMG обаче ние като доставчик на услуги не сме задължени да наблюдаваме предадена или съхранявана чужда информация.\n\nЗадълженията за премахване или блокиране на използването на информация съгласно общите закони остават незасегнати от това. Отговорност в това отношение обаче е възможна едва от момента на узнаване на конкретно нарушение на правото.',
    },
    {
      id: 'liability-links',
      title: 'Отговорност за връзки',
      body:
        'Нашето предложение съдържа връзки към външни уебсайтове на трети страни, върху чието съдържание ние нямаме влияние. Поради това не можем да поемем гаранция за това чуждо съдържание. За съдържанието на свързаните страници винаги отговаря съответният доставчик или оператор на страниците.',
    },
    {
      id: 'copyright',
      title: 'Авторско право',
      body:
        'Създадените от операторите на сайта съдържания и произведения на тези страници са обект на авторско право. Възпроизвеждането, обработката, разпространението и всякакъв вид използване извън границите на авторското право изискват писменото съгласие на съответния автор или създател.\n\nИзтеглянията и копията на тази страница са разрешени само за лична, нетърговска употреба.',
    },
  ],
};
